/* istanbul ignore file */
import { FormTemplate, DateInput, SubmitFormButton } from 'framework/form';
import { LoadingFormLayout, FormSection, FormRow } from 'framework/ui/layout';
import useCostAccountingService from 'domain/finance/costAccounting/shared/costAccountingService';
import costAccountingDashboardValidation from 'domain/finance/costAccounting/dashboard/costAccountingDashboardValidation';
import MappingMetricsWrapper from 'domain/finance/costAccounting/dashboard/MappingMetricsWrapper';
import { DATE_FORMAT } from 'framework/utils';
import CostReportSourceDropdown from './CostReportSourceDropdown';
import { ListHeader, ListPageLayout } from 'framework/list';

const CostAccountingDashboard = () => {
  const { getCostReport } = useCostAccountingService();

  const submitForm = async (data: any) => {
    return getCostReport(data);
  };

  const getValidationSchema = () => {
    return Promise.resolve(costAccountingDashboardValidation);
  };

  return (
    <ListPageLayout header={<ListHeader label="Cost Accounting" icon="fa-clock-o" />}>
      <FormTemplate submitFormFunc={submitForm} getValidationSchemaFunc={getValidationSchema} handleDirty={false}>
        <FormRow colXl={2}>
          <DateInput label="Period from" source="from" dateFormat={DATE_FORMAT.API_ONLY_DATE} />
          <DateInput label="To" source="to" dateFormat={DATE_FORMAT.API_ONLY_DATE} />
          <CostReportSourceDropdown label="Source" source="sourceType" />
        </FormRow>

        <FormSection title="Mapping metrics">
          <MappingMetricsWrapper fromDateSource="from" toDateSource="to" />
        </FormSection>

        <SubmitFormButton sx={{ mr: 1 }}>Download cost report</SubmitFormButton>

        <LoadingFormLayout />
      </FormTemplate>
    </ListPageLayout>
  );
};

export default CostAccountingDashboard;
